/**
 * Firebase Auth for customer login (Google, Phone OTP).
 * Requires REACT_APP_FIREBASE_* env vars. If missing, getAuth() returns null and social/OTP sign-in is disabled.
 */
import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';

const config = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

let auth = null;
if (config.apiKey && config.projectId) {
  try {
    const app = initializeApp(config);
    auth = getAuth(app);
  } catch (e) {
    console.warn('Firebase init failed:', e);
  }
}

export { auth, GoogleAuthProvider };
